import React, {useState} from "react"
import "external-svg-loader"
import CookieConsent from "./cookieConsent"
import {graphql, useStaticQuery} from "gatsby"
import LanguageContext from "../context/LanguageContext"
import Header from "./header"
import FootNotes from "./footNotes"
import Footer from "./footer"
import {HighlightProvider} from "../context/HighlightContext"

const Layout = (props) => {

    const { children, pageLanguage, footNotesData, pageContext } = props;

    const hideHeaderFooter = pageContext?.hideGlobalHeaderFooter === true;

    const data = useStaticQuery(graphql`
      query AllLocalesQuery {
        strapi {
          i18NLocales {
            code
          }
        }
      }
  `)

    const availableLanguages = data.strapi.i18NLocales.map(
        (locale) => locale.code
    );

    const [currentLanguage, setCurrentLanguage] = useState(pageLanguage || 'de');

    const contextValue = {
        language: currentLanguage,
        availableLanguages: availableLanguages,
        setLanguage: setCurrentLanguage
    };

    return (
        <HighlightProvider>
            <LanguageContext.Provider value={contextValue}>
                {!hideHeaderFooter && <Header />}
                <main>
                    <CookieConsent/>
                    {children}
                </main>
                <FootNotes contentSections={footNotesData}/>
                {!hideHeaderFooter && <Footer />}
            </LanguageContext.Provider>
        </HighlightProvider>
    )
}

export default Layout